import { type ExternalResponse, type Response } from './get-region-by-zip-code';

export default function adapter(externalResponse: ExternalResponse) {
  const response: Response = {
    data: externalResponse,
  };

  return response;
}
